<mat-nav-list [class.sidebar-collapse]='collapse'>
  <ng-container *ngIf="!collapse; else hamburger">
    <a mat-list-item class="arrow" [ngClass]="{'border-bottom-element': isClicked}" routerLinkActive="active"
      (click)="toggleMenu()">
      <div class="trigger">
        <div class="line line1"></div>
        <div class="line"></div>
        <div class="line line2"></div>
      </div>
    </a>
  </ng-container>
  <ng-template #hamburger>
    <a mat-list-item class="hamburger" [ngClass]="{'border-bottom-element': isClicked}" routerLinkActive="active"
      (click)="toggleMenu()">
      <div class="trigger" [ngClass]="{'isClicked': isClicked}">
        <div class="line line1"></div>
        <div class="line"></div>
        <div class="line line2"></div>
      </div>
    </a>
  </ng-template>
  <ng-container *ngFor="let item of menuItems; let isLast = last">
    <ng-container *ngIf="item.children?.length">
      <div class="d-flex flex-column" [ngClass]="">
        <a *ngIf="(isLoggedIn && item.role === role.roleCCJAdmin) || item.role === role.rolePublic" mat-list-item
          class="{{item.icon}}" (click)="onMenuClick(item)"
          [ngClass]="{ 'no-hover': !collapse, 'border-bottom-element': isClicked, 'active': router.isActive(item.link, matchOptions) }"
          disableRipple>
          <mat-icon class="icon" aria-hidden="false" [svgIcon]="item.icon"></mat-icon>
          <span [hidden]="collapse" class="pl-3">{{item.title}}</span>
        </a>
        <ul class="sub-menu" [hidden]="collapse">
          <li class="sub-menu__item" *ngFor="let child of item.children" (click)="onMenuClick(item)"
            [ngClass]="{ 'active': router.isActive(item.link, matchOptions) }" [routerLink]="[child.link]"
            [routerLinkActive]="'text-underline'">
            {{child.title}}
          </li>
        </ul>
      </div>
    </ng-container>
    <ng-container *ngIf="!item.children">
      <a *ngIf="(isLoggedIn && item.role === role.roleCCJAdmin) || item.role === role.rolePublic" mat-list-item
        class="{{item.icon}}"
        [ngClass]="{ 'border-bottom-element': isClicked, 'border-top-element': isClicked && isLast, 'mt-auto': isLast && !isSdMenu }"
        [routerLink]="[item.link]" (click)="onMenuClick(item)" routerLinkActive="active">
        <mat-icon class="icon" aria-hidden="false" [svgIcon]="item.icon"></mat-icon>
        <span [hidden]="collapse" class="pl-3">{{item.title}}</span>
      </a>
      <a *ngIf="(!isLoggedIn && item.role === role.roleCCJAdmin)" mat-list-item class="{{item.icon}}"
        [ngClass]="{ 'border-bottom-element': isClicked, 'un-login-user': true }" (click)="showLogin(item.link)">
        <mat-icon class="icon" aria-hidden="false" [svgIcon]="item.icon"></mat-icon>
        <span [hidden]="collapse" class="pl-3">{{item.title}}</span>
      </a>
    </ng-container>
  </ng-container>
</mat-nav-list>
